import React from 'react';
import WizardItem, { IWizardItem } from '../WizardItem';
import styles from './WizardScreen.module.scss';
import FirstUpper from '../../../../BaseModule/Components/FirstUpper';

interface Props {
	item: IWizardItem;
	isCarouselChild?: boolean;
}

const WizardScreen: React.FC<Props> = ({ item, isCarouselChild = false }) => {
	return (
		<div className={styles.wrapper}>
			{item?.settings?.showLogo != false && !isCarouselChild && (
				<img
					src='./../../dist/logos/square/meddiapp.png'
					alt='logo'
					height='55px'
				/>
			)}
			{item?.title && (
				<div className={styles.title}>
					<FirstUpper>{item.title}</FirstUpper>
				</div>
			)}
			{item?.description && (
				<div className={styles.description}>{item.description}</div>
			)}
			{item?.children?.length && item.children.length > 0 && (
				<div className={styles.content}>
					{item.children.map((child, key) => (
						<React.Fragment key={key}>
							<WizardItem item={child} />
						</React.Fragment>
					))}
				</div>
			)}
		</div>
	);
};

export default WizardScreen;
